import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpsellAdData } from "gql/graphql";

export type UpsellAdDataState = {
  loading: boolean;
  healthReportUpsell: null | UpsellAdData;
};

const initialState: UpsellAdDataState = {
  loading: false,
  healthReportUpsell: null,
};

const upsellAdDataSlice = createSlice({
  name: "upsellAdData",
  initialState,
  reducers: {
    setUpsellAdDataLoading(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        loading: action.payload,
      };
    },

    setUpsellAdData(state, action: PayloadAction<UpsellAdDataState>) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setUpsellAdDataLoading, setUpsellAdData } =
  upsellAdDataSlice.actions;

export default upsellAdDataSlice;
